import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { CircularProgress, Grid, Typography, Checkbox } from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";

import useSnackbarAlert from "../../../utils/snackbarHandlers";
import CommonButton from "../../common/button/Button";
import CommonInput from "../../common/input/InputBox";
import { debounce } from "lodash";
// import { CheckBox } from "@mui/icons-material";

const initialData = {
  gameNumber: "",
  packNumber: "",
};

const AddInventory: React.FC<{}> = () => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  const { t } = useTranslation("translation");
  const navigate = useNavigate();
  let localData = localStorage.getItem("UserData");
  const shopownerData = localData ? JSON.parse(localStorage.getItem("UserData") || "") : null;
  const [loading, setLoading] = React.useState<boolean>(false);
  const [scannedCode, setScannedCode] = React.useState<string>("");
  const [addMoreTickets, setAddMoreTickets] = React.useState(true);

  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  const validationSchema = yup.object().shape({
    gameNumber: yup.string().required(t("gameNumberRequiredText")),
    packNumber: yup
      .string()
      .required(t("packNumberRequiredText"))
      .min(7, t("packNumberLengthErrorText"))
      .max(7, t("packNumberLengthErrorText")),
  });

  const onFormSubmit = () => {
    console.log("Values on form submit - ", values);
    setLoading(true);
    const requestBody = {
      userId: shopownerData?.uId,
      gameNumber: values.gameNumber,
      packNumber: values.packNumber,
      confirmDate: new Date().toISOString().split("T")[0],
      actionDate: new Date().toISOString().split("T")[0],
    };

    axios
      .post(`${apiBaseURL}/api/inventory/saveInventory`, requestBody)
      .then((response) => {
        if (response?.status === 200) {
          showSuccessMessage(t("shopAddSuccessfullMessage", "Inventory Added Successfully"));
          if(addMoreTickets) {
            formik.resetForm();
            setScannedCode("");
          } else {
            navigate("/shopOwner/fetchInventories");
          }
        }
      })
      .catch((error: any) => {
        console.log("err", error);
        showErrorMessage(
          error.response.data.message ? error.response.data.message : t("somethingWentWrong"),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: initialData,
    onSubmit: onFormSubmit,
    validationSchema: validationSchema,
    enableReinitialize: true,
  });

  const handleAddMoreTicketsChange = (e: any) => {
    setAddMoreTickets(e.target.checked);
  };

  const { values, errors, handleSubmit, touched, handleChange, handleReset } = formik;

  const onSuccessFullScan = async (data: string) => {
    // if (data) {
    setScannedCode(data);
    const gameNumber = data.substring(0, 4);
    const packNumber = data.substring(4, 11);
    await formik.setFieldValue("packNumber", packNumber);
    await formik.setFieldValue("gameNumber", gameNumber);
    // setTimeout(() => {
    //   onFormSubmit();
    // }, 1000);
    // }
  };

  React.useEffect(() => {
    if(scannedCode.length == 14) {
      // Submit the form after values are set
      formik.submitForm();
    }
  }, [scannedCode]);

  const onScanError = (error: any) => {
    showErrorMessage(error);
    formik.setFieldValue("packNumber", "");
    formik.setFieldValue("gameNumber", "");
  };

  return (
    <>
      <Grid className='h-screen bg-white p-[2%]'>
        <Grid className='text-[1.25rem] font-[500]'>{t("inventory")}</Grid>
        <Grid className='col-span-1'>
          <Grid>
              <Checkbox
                id='add-more-tickets-checkbox'
                checked={addMoreTickets}
                onChange={handleAddMoreTicketsChange}
              />
              <label htmlFor='add-more-tickets-checkbox'>Add More Tickets</label>
          </Grid>
        </Grid>

        <Grid className='col-span-1'>
          <Grid>
            <CommonInput
              id='scan-code-input-box'
              fullWidth
              name='scannedCode'
              label={t("scanCodeInputLabel")}
              placeholder={t("scanCodeInputPlaceholder")}
              onChange={(e) => onSuccessFullScan(e.target.value)}
              value={scannedCode}
              className='input-box'
              sx={true}
              // error={touched?.gameNumber && errors?.gameNumber ? true : false}
              // helperText={errors?.gameNumber && touched?.gameNumber ? errors?.gameNumber : ""}
              removeBottomMargin={true}
            />
          </Grid>
        </Grid>

        <br />
        <Typography variant='h6' className='text-[1.25rem] font-[500]'>
          {t("or", "Or")}
        </Typography>
        <br />
        <Grid className='grid grid-cols-2 mt-1 gap-12'>
          <Grid className='col-span-1'>
            <Grid>
              <CommonInput
                id='game-number-input-box'
                fullWidth
                name='gameNumber'
                label={t("gameNumberInputLabel")}
                placeholder={t("gameNumberInputPlaceholder")}
                onChange={handleChange}
                value={values?.gameNumber}
                className='input-box'
                sx={true}
                error={touched?.gameNumber && errors?.gameNumber ? true : false}
                helperText={errors?.gameNumber && touched?.gameNumber ? errors?.gameNumber : ""}
              />
            </Grid>
          </Grid>

          <Grid className='col-span-1'>
            <Grid>
              <CommonInput
                id='game-number-input-box'
                fullWidth
                name='packNumber'
                label={t("packNumberInputLabel")}
                placeholder={t("packNumberInputPlaceholder")}
                onChange={handleChange}
                value={values?.packNumber}
                className='input-box'
                sx={true}
                error={touched?.packNumber && errors?.packNumber ? true : false}
                helperText={errors?.packNumber && touched?.packNumber ? errors?.packNumber : ""}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Buttons panel */}
        <Grid className='mt-2 h-[10%] flex justify-start gap-4'>
          <Grid className='w-[15%]'>
            <CommonButton
              id='submit-button'
              className='login-button'
              variant='contained'
              size='small'
              disabled={loading}
              onClick={() => {
                handleSubmit();
              }}
            >
              {t("save")}
              {loading && (
                <CircularProgress
                  color='inherit'
                  size={14}
                  thickness={6}
                  style={{ marginLeft: "8px" }}
                />
              )}
            </CommonButton>
          </Grid>
          <Grid className='w-[15%]'>
            <CommonButton
              id='reset-button'
              className='sign-up-button'
              variant='outlined'
              size='small'
              onClick={(e) => {
                handleReset(e);
              }}
            >
              {t("reset")}
            </CommonButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AddInventory;
